import React, { useState, useEffect } from 'react';
import getSource from '../../utils/get-source';
import { appStorage, parseQueryString } from '../../utils/utils'
import apiRequest from '../../utils/api.request';
import config from '../../config.json';
import useLoader from '../../hooks/use-loader';
import Onboarding from '../OnBoarding';
import './OnboardingWrapper.css';

const source_array_for_surveyv5 = ["emp_xp"]
const array_for_previous_resp = ["covid_survey_v4", "covid_survey_v5"]
export const covid_survey_v5 = "covid_survey_v5";
export const covid_survey_v4 = "covid_survey_v4";
export const post_vaccine_covid_survey_v1 = "post_vaccine_covid_survey_v1";
let workflowId;
let clearWorkflowId = false;

const get_survey_id = (workflowId) => {
  switch(workflowId){
    case covid_survey_v5:
      return covid_survey_v5;
    case covid_survey_v4:
      return covid_survey_v5
    case post_vaccine_covid_survey_v1:
      return covid_survey_v5
  }
}

const OnboardingWrapper = () => {
  const [showSurvey, toggleShowSurvey] = useState(false);
  const { showLoading, hideLoading } = useLoader();
  const [hideButton, toggleHideButton] = useState(false);
  useEffect(() => {
    showLoading();
    const params = parseQueryString();
    getSource()
      .then(({ source_user_id, source_id, business_id }) => {
        if ((source_array_for_surveyv5.indexOf(source_id) < 0) || !source_user_id) {
          workflowId = (params.workflow_id || (config.covidWorkFlowID || covid_survey_v4));
          toggleShowSurvey(true);
        }
        else {
          switch (source_id) {
            case "emp_xp": {
              const { source_relation, source_user_relation_id, workflow_id } = parseQueryString();
              if (!(business_id && source_relation && source_user_relation_id && array_for_previous_resp.indexOf(workflow_id) > -1)) {
                workflowId = (workflow_id || (config.covidWorkFlowID || covid_survey_v4));
                toggleShowSurvey(true);
                break;
              }
              getCovidSurveyId(source_user_id, source_id, business_id, source_relation, source_user_relation_id)
                .then((response) => {
                  workflowId = response;
                  toggleShowSurvey(true);
                })
              break;
            }
            default: {
              workflowId = (params.workflow_id || config.covidWorkFlowID || covid_survey_v4);
              toggleShowSurvey(true);
              break;
            }
          }
        }
      })
  }, [])

  const getCovidSurveyId = async (source_user_id, source_id, business_id, source_relation, source_user_relation_id) => {
    const url = config.get_survey_result;
    const params = {
      source_user_id: source_user_id,
      source_id: source_id,
      business_id: business_id,
      source_relation: source_relation,
      source_user_relation_id: source_user_relation_id
    }
    const response = await apiRequest(url, undefined, false, false, false, false, false, false, false, params);
    if (response.created_at_ist && response.workflow_id !== "unknown" && response.covid_19_risk !== "unknown") {
      return get_survey_id(response.workflow_id)
    }
    return covid_survey_v4;
  }

  useEffect(() => {
    if (showSurvey) {
      appStorage.setItem("workflow_id", workflowId);
      hideLoading();
    }
  }, [showSurvey])

  const handleClick = () => {
    toggleShowSurvey(false);
    showLoading();
    workflowId = covid_survey_v4;
    setTimeout(() => {
      clearWorkflowId = true;
      toggleShowSurvey(true);
    }, 0)
  }

  const hideSurveyButton = () => {
    toggleHideButton(true)
  }

  return (
    <div>
      {
        showSurvey ?
          <div className={workflowId === covid_survey_v5 ? "paddingLarge" : ""}>
            {(workflowId === covid_survey_v5 && (!hideButton)) ?
              <button className="buttonList" onClick={handleClick} style={{ background: "#034ea1" }}>Take complete survey</button>
              :
              <></>
            }
            <Onboarding not_override_workflow_id={true} prefer_app_store={true} padding_top_small={workflowId === covid_survey_v5} clear_workflow={clearWorkflowId} hideSurveyButton={hideSurveyButton} />
          </div>
          :
          <></>
      }
    </div>

  )

}

export default OnboardingWrapper;